import React, { useState } from 'react'
import { Button, Flex, Heading, Text } from '@pancakeswap/uikit'
import { useSignMessage } from '@pancakeswap/wagmi'
import styled from 'styled-components'
import useToast from 'hooks/useToast'
import LockCard from './components/LockCard'
import LockCards from './components/LockCards'
import useLockList from './hooks/useLockList'
import usePromoCode from './hooks/usePromoCode'

const Banner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.secondary}88;
  background: ${({ theme }) => theme.colors.secondary}22;
  padding: 8px;

  button {
    margin-top: 4px;
    border-width: 1px;
    font-size: 13px;
    font-weight: 500;
  }
`

const AllLocks = () => {
  const [status, setStatus] = useState(false)
  const [promoCode, setPromoCode] = useState("")
  const { lockList } = useLockList(status)
  const { handleFetchPromoCode } = usePromoCode()
  const { signMessageAsync } = useSignMessage()
  const { toastError } = useToast()

  const toggleStatus = () => {
    setStatus(!status)
  }

  const onGetPromoCode = async () => {
    const epochTime = new Date().getTime()
    try {
      let sig
      try {
        sig = await signMessageAsync({ message: `Generate one time promo code at ${epochTime}` })
      } catch (err) {
        throw ("User rejected request").toString()
      }
      const fetchedCode = await handleFetchPromoCode(epochTime, sig)
      setPromoCode(fetchedCode)
    } catch (err) {
      console.error('Error ==> ', err)
      setPromoCode("")
      toastError('Error', err.toString())
    }
  }

  return (
    <>
      {/* <Banner>
        <Text>Users who locked more than 20K CANDY for over 2 years will get promo code for Hoodie.</Text>
        {
          promoCode ? (
            <Text>Your promo code is: <strong>{promoCode}</strong></Text>
          ) : (
            <>
              <Text>If you are a candidate, please get promo code.</Text>
              <Button scale='sm' variant='secondary'
                onClick={onGetPromoCode}>
                Get Promo Code
              </Button>
            </>
          )
        }
      </Banner> */}
      <LockCards isSingle={lockList.length === 0}>
        {
          lockList.length === 0 ? (
            <Flex justifyContent='center' mt='24px'>
              <Heading scale='lg'>You do not have Lock.</Heading>
            </Flex>
          ) : (lockList.map((lockData) => (
            <LockCard key={lockData.lid} data={lockData} onUnlocked={toggleStatus} />
          )))
        }
      </LockCards>
    </>
  )
}

export default AllLocks
